<template>
  <section id="faq" class="faq-juegos">
    <!-- Header con logo y título -->
    <div class="faq-header">
      <img src="@/assets/logo_sin_fondo_recortado.png" alt="Logo Gamer" class="faq-logo" />
      <h2 class="faq-titulo">🎮 Servicios para Gamers</h2>
    </div>

    <!-- Lista FAQ -->
    <div class="faq-lista">
      <div
        v-for="(item, index) in servicios"
        :key="index"
        class="faq-item"
        :class="{ abierto: item.abierto }"
        :style="{ animationDelay: (index * 0.2) + 's' }"
      >
        <div class="faq-pregunta" @click="toggle(index)">
          <span>{{ item.titulo }}</span>
          <svg
            class="faq-icono"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <transition name="desplegar">
          <div v-if="item.abierto" class="faq-respuesta">
            <p>{{ item.descripcion }}</p>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiciosGamerFAQ",
  data() {
    return {
      servicios: [
        {
          titulo: "🎮 Streaming en Vivo",
          descripcion:
            "Transmite tus partidas a plataformas como Twitch o YouTube Gaming con configuración profesional de audio y video.",
          abierto: false,
        },
        {
          titulo: "🕹️ Torneos y Competencias",
          descripcion:
            "Organización de torneos de eSports y competencias locales o en línea para jugadores de todos los niveles.",
          abierto: false,
        },
        {
          titulo: "💻 Optimización de PC Gamer",
          descripcion:
            "Mejoramos el rendimiento de tu PC para videojuegos, instalando drivers, overclocking y optimización de software.",
          abierto: false,
        },
        {
          titulo: "🖥️ Instalación de Juegos y Plataformas",
          descripcion:
            "Instalamos juegos, plataformas como Steam, Epic Games, Origin y configuramos todo para jugar sin problemas.",
          abierto: false,
        },
        {
          titulo: "🎧 Soporte de Hardware Gamer",
          descripcion:
            "Asistencia con periféricos, auriculares, teclados, ratones y monitores para obtener la mejor experiencia gaming.",
          abierto: false,
        },
        {
          titulo: "📊 Asesoría en Streaming y eSports",
          descripcion:
            "Consejos personalizados para mejorar tu canal, crecer en redes y competir en torneos profesionales.",
          abierto: false,
        },
        {
          titulo: "🛒 Venta de Consolas y Accesorios",
          descripcion:
            "Consolas nuevas, usadas y periféricos de alta calidad para mejorar tu setup gamer.",
          abierto: false,
        },
        {
          titulo: "🌐 Configuración de Redes Gamer",
          descripcion:
            "Optimización de redes y routers para minimizar lag y mejorar la conexión en juegos en línea.",
          abierto: false,
        },
      ],
    };
  },
  methods: {
    toggle(index) {
      this.servicios[index].abierto = !this.servicios[index].abierto;
    },
  },
};
</script>

<style scoped>
.faq-juegos {
  background: url('@/assets/Img/Banners/jugando.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  position: relative;
  color: #fff;
}

.faq-juegos::before {
  content: "";
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 0;
}

.faq-juegos > * {
  position: relative;
  z-index: 1;
}

/* Header con logo y título */
.faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  margin-bottom: 2rem;
  animation: fadeInDown 1s ease-in-out;
}

.faq-logo {
  width: 70px;
  height: auto;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 242, 255, 0.4);
  animation: pulse 2s infinite;
}

.faq-titulo {
  font-size: 2.4rem;
  font-weight: bold;
  color: #00f2ff;
  text-shadow: 0 2px 6px rgba(0, 242, 255, 0.8);
  text-align: center;
}

/* FAQ lista */
.faq-lista {
  max-width: 850px;
  margin: 0 auto;
  text-align: left;
}

.faq-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 14px;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeInUp 0.8s forwards;
}

.faq-item.abierto {
  border: 1px solid #00f2ff;
  box-shadow: 0 6px 20px rgba(0, 242, 255, 0.4);
}

.faq-pregunta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.2rem;
  transition: background 0.3s ease;
}

.faq-pregunta:hover {
  background: rgba(0, 242, 255, 0.1);
}

.faq-icono {
  width: 26px;
  height: 26px;
  transition: transform 0.4s ease;
}

.faq-item.abierto .faq-icono {
  transform: rotate(180deg) scale(1.2);
  color: #00f2ff;
}

.faq-respuesta {
  padding: 1rem 1.2rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #ddd;
  animation: fadeIn 0.4s ease;
}

/* Animaciones */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pulse {
  0% { transform: scale(1); box-shadow: 0 0 10px rgba(0,242,255,0.6); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(0,242,255,0.9); }
  100% { transform: scale(1); box-shadow: 0 0 10px rgba(0,242,255,0.6); }
}

/* Transición desplegable */
.desplegar-enter-active,
.desplegar-leave-active {
  transition: max-height 0.5s ease, opacity 0.5s ease;
}
.desplegar-enter,
.desplegar-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
